import { CartProps, CartEditorProps } from './Cart.types';

/**
 * 장바구니 컴포넌트의 속성을 변환하는 어댑터 함수
 * 여러 경로에서 속성을 가져와 표준화된 형태로 반환합니다.
 */
export function adaptCartProps(originalProps: any): CartProps {
  // 디바이스 타입 결정 (모바일 또는 PC)
  const deviceType = originalProps.viewMode === 'mobile' ? 'mobile' : 'pc';
  
  // 디바이스별 속성 적용을 위한 처리
  let deviceProps: Record<string, any> = {};
  
  // 디바이스별 속성이 있는 경우 해당 디바이스 속성을 적용
  if (originalProps.deviceProperty && originalProps.deviceProperty[deviceType]) {
    deviceProps = originalProps.deviceProperty[deviceType];
  }
  
  // 컴포넌트 속성 추출
  // 여러 경로에서 속성을 확인하고 우선순위에 따라 적용
  const className = originalProps.className || 
                    originalProps.componentProps?.className || 
                    "cart-component-wrapper padding-tb-40";
  
  const title = deviceProps.title ||
               originalProps.title || 
               originalProps.componentProps?.title || 
               "";
  
  const emptyText = deviceProps.emptyText ||
                   originalProps.emptyText || 
                   originalProps.componentProps?.emptyText || 
                   "";
  
  const shippingFee = deviceProps.shippingFee ||
                      originalProps.shippingFee || 
                      originalProps.componentProps?.shippingFee || 
                      0;
  
  const showStock = deviceProps.showStock !== undefined ? deviceProps.showStock :
                    originalProps.showStock !== undefined ? originalProps.showStock :
                    originalProps.componentProps?.showStock !== undefined ? originalProps.componentProps.showStock :
                    false;
  
  // 원본 스타일 가져오기
  let style = { ...(originalProps.style || {}) };
  
  // 디바이스별 스타일 적용
  if (originalProps.style?.deviceProperty?.[deviceType]) {
    style = {
      ...style,
      ...originalProps.style.deviceProperty[deviceType]
    };
  }
  
  // 최종 속성 반환
  return {
    ...originalProps,
    className,
    style,
    componentProps: {
      ...(originalProps.componentProps || {}),
      title,
      emptyText,
      shippingFee,
      showStock
    },
    title,
    emptyText,
    shippingFee,
    showStock
  };
}

/**
 * 에디터 모드용 장바구니 컴포넌트 속성 어댑터
 * 에디터에서 필요한 추가 속성(isSelected, updateComponent 등)을 포함
 */
export function adaptCartEditorProps(originalProps: any): CartEditorProps {
  // 기본 속성 적용
  const adaptedProps = adaptCartProps(originalProps) as CartEditorProps;
  
  // 에디터 관련 속성 추가
  adaptedProps.isSelected = originalProps.isSelected || false;
  adaptedProps.isPreview = originalProps.isPreview || false;
  adaptedProps.isEditor = true;
  adaptedProps.viewMode = originalProps.viewMode || 'pc';
  adaptedProps.updateComponent = originalProps.updateComponent || (() => {});
  
  return adaptedProps;
} 